const requireModule = require.context('.', true, /^((?!index|\.unit\.).)*\.js$/);
const root = [];

requireModule.keys().forEach((fileName) => {
  const moduleDefinition = requireModule(fileName);
  root.push(...(moduleDefinition.default || []));
});

export default root;
